import o from "./index83.js";
import * as t from "./index84.js";
const m = {
  ...t,
  ...o
};
export {
  m as default
};
